import { useTranslation } from "react-i18next";

import CreateAccountSvg from "@app-assets/images/userGuide/create-account.svg";
import LinkBankSvg from "@app-assets/images/userGuide/link-bank.svg";
import OpenAppSvg from "@app-assets/images/userGuide/open-app.svg";
import RingListSvg from "@app-assets/images/userGuide/ring-list.svg";
import SelectAccessKeySvg from "@app-assets/images/userGuide/select-access-key.svg";
import SelectBuildingSvg from "@app-assets/images/userGuide/select-building.svg";
import MTBreadcrumb from "@app-components/header/MTBreadcrumb";
import GuideImage from "@app-components/userGuide/GuideImage";
import { getRoutes } from "@app-utils/routes";

export default function AccessControlPage() {
  const { t } = useTranslation();
  const routes = getRoutes(t);

  const steps = [
    {
      title: t("page.guide.step", [1]),
      src: OpenAppSvg,
      description: t("page.guide.download"),
    },
    {
      title: t("page.guide.step", [2]),
      src: CreateAccountSvg,
      description: t("page.guide.createAccount"),
    },
    {
      title: t("page.guide.step", [3]),
      src: RingListSvg,
      description: t("page.guide.ringList"),
    },
    {
      title: t("page.guide.step", [4]),
      src: SelectAccessKeySvg,
      description: t("page.guide.selectAccessKeyTab"),
    },
    {
      title: t("page.guide.step", [5]),
      src: SelectBuildingSvg,
      description: t("page.guide.selectBuilding"),
    },
    {
      title: t("page.guide.step", [6]),
      src: LinkBankSvg,
      description: t("page.guide.addAccessKey"),
    },
  ];

  return (
    <div className="container mt-ugd faq faq-detail">
      <MTBreadcrumb items={[routes.home, routes.accessControl]} />
      <div className="mt-ugd">
        <div className="mt-title">
          <span>{t("page.product.guide.accessKey")}</span>
        </div>

        <div className="mt-ugd__link-imgs">
          {steps.map((step) => {
            return (
              <GuideImage
                key={step.title}
                className="ur-img"
                title={step.title}
                src={step.src}
                description={step.description}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
